import { render, staticRenderFns } from "./SecretariatOrdersEdit.vue?vue&type=template&id=05afef9a&lang=pug&"
import script from "./SecretariatOrdersEdit.vue?vue&type=script&lang=ts&"
export * from "./SecretariatOrdersEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports